<template>
    <div>
        <div id="container" >
            <br>Loading...<br><br>
        </div>
    </div>
</template>

<script>
    export default {
        name: "marzipanoViewer",
        props: ['tour_folder', 'tour_xml'],
        data: function(){
          return {
              pano: null,
              skin: null,
              checkingInterval: null,
              width: '100%',
              height: '100%'
          }
        },
        methods:{
            renderpano () {
                clearInterval(this.checkingInterval);
                // create the panorama player with the container
                this.pano = new window.pano2vrPlayer("container");
                // add the skin object
                console.log(window.pano2vrSkin);
                this.skin = new window.pano2vrSkin(this.pano);
                // load the configuration
                this.pano.readConfigUrlAsync(this.tour_folder + "/" + this.tour_xml, null, this.tour_folder);

                this.pano.setMargins(0, 0, 0, 0);
                // this.pano.setViewerSize(this.width, this.height);

                this.pano.on("changenode", function() {
                    let syncdata = {
                        node: this.pano.getCurrentNode()
                    }
                    this.$emit('sync-nav', syncdata);
                }.bind(this));

                this.pano.on("positionchanged", function() {
                    let syncdata = {
                        pan: this.pano.getPan(),
                        tilt: this.pano.getTilt()
                    }
                    this.$emit('sync-view', syncdata);

                }.bind(this))

                this.pano.on("configloaded", function() {
                    this.$emit('panoready');
                }.bind(this))

                this.pano.on("fullscreenexit", function() {
                    this.$emit('exit-fullscreen');
                }.bind(this));

            },
            pano_gotonextnode: function() {
                //console.log(this.pano.getCurrentNode(), this.pano.getNextNode());
                let next = this.pano.getNextNode();
                this.pano.openNext("{" + next + "}");
                return this.pano.getNodeTitle(next);
            },
            pano_gotoprevnode: function() {
                //console.log(this.pano.getCurrentNode(), this.pano.getNextNode());
                let prev = this.pano.getPrevNode();
                this.pano.openNext("{" + prev + "}");
                return this.pano.getNodeTitle(prev);
            },
            pano_gotonode: function(_nodeid) {
                this.pano.openNext("{" + _nodeid + "}");
                return this.pano.getNodeTitle(_nodeid);
            },
            pano_orient (_pan, _tilt){
                this.pano.setPan(_pan);
                this.pano.setTilt(_tilt);
            },
            pano_gofullscreen () {
                this.pano.setFullscreen(true);
            },
            pano_getNodeIds(){
                return this.pano.getNodeIds();
            },
            pano_getNodesInfo(){
                let nodesinfo = [];
                for(const n of this.pano.getNodeIds()){
                    nodesinfo.push({id:n, title:this.pano.getNodeTitle(n)})
                }
                return nodesinfo;
            },
            pano_getCurrentNode(){
                return this.pano.getNodeTitle(this.pano.getCurrentNode());
            },
            setSize(_width, _height){
                this.width = _width;
                this.height = _height;
                if(this.pano){
                    this.pano.setViewerSize(this.width, this.height);
                }
            }
        },
        created: function (){
            let pano = document.createElement('script');
            pano.setAttribute('src',"pano2vr_player.js");
            pano.setAttribute('type',"text/javascript");
            document.head.appendChild(pano);
            let skin = document.createElement('script');
            skin.setAttribute('src',"skin.js");
            skin.setAttribute('type',"text/javascript");
            document.head.appendChild(skin);
        },
        mounted: function () {
            this.checkingInterval = setInterval(function(){
                console.log(window.pano2vrPlayer);
                if (window.pano2vrPlayer) {
                    this.renderpano();
                }
            }.bind(this), 500) //or whatever interval you want to check
        }
    }
</script>

<style scoped>

</style>
